
import './receiptsDetails.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import brand from '../../service/brand';
import zone from '../../service/zone';
import user from '../../service/user';
import receipt from '../../service/receipt';

import menuLayout from '../../directive/menu-layout';
import dateFormat from '../../directive/date-format';
import storeDateSelector from '../../directive/store-date-selector';

import routing from './receiptsDetails.routes';
import ReceiptsDetailsController from './receiptsDetails.controller';

export default angular.module('page.receiptsDetails', [
		uirouter,

		brand,
		zone,
		user,
		receipt,

		menuLayout,
		dateFormat,
		storeDateSelector,
		'ui.bootstrap.datetimepicker',
		'angularUtils.directives.dirPagination',
	])
	.config(routing)
	.controller('ReceiptsDetailsController', ReceiptsDetailsController)
	.name;



// WEBPACK FOOTER //
// ./src/page/receiptsDetails/index.js